<template>
    <div class="btn-group btn-group-toggle">
        <a v-for="option in options" class="btn btn-primary-flat ms-1"
             :class="{'active': (typeof option === 'object' && value === option.value) || value === option}"
             @click="selectOption(option)">
            {{ typeof option === 'object' ? option.label : option }}
            <div class="btn-counter ms-1">{{option.counter}}</div>
        </a>
    </div>
</template>

<script>

export default {
    name: 'BtnGroupToggleWithCounter',
    props: {
        options: {
            default: [],
        },
        value: {
            default: null,
        },
    },
    data() {
        return {};
    },
    methods: {
        selectOption(option) {
            if (typeof option === 'object') {
                if (option.value === this.value) {
                   //TODO deselect value
                } else {
                    this.$emit('input', option.value);
                }
            } else {
                this.$emit('input', option);
            }
        },
    },
};
</script>
<style scoped>
.btn-counter {
    display: flex;
    padding: 2px 10px;
    align-items: center;
    border-radius: 16px;
    background: #F2F4F7;
    mix-blend-mode: multiply;
}

.btn-check:checked + .btn, .btn-check:active + .btn, .btn:active, .btn.active {
    box-shadow: none;
    background: #F9F5FF;
    color: #6941C6;
}

</style>
